import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Router, RouterLink, RouterLinkActive } from '@angular/router'
import { MatIcon } from '@angular/material/icon'
import { MenuListModel } from '../../models/menu.model'
import { LISTROUTES } from '../routes'
import { AuthService } from '../../services/auth/auth.service'
import { GlicoLogoComponent } from '../../../shared/components/glico-logo/glico-logo.component'

// Ícone de cada grupo/item de primeiro nível do menu
const ICONES_MENU: Record<string, string> = {
  Home: 'space_dashboard',
  Cadastro: 'person_add',
  'Cadastrar Tipos': 'category',
  Relatórios: 'insert_chart',
  'Pendência - Pacientes': 'notifications_active',
}

@Component({
  selector: 'template-sidebar',
  imports: [RouterLink, RouterLinkActive, MatIcon, GlicoLogoComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  providers: [AuthService],
})
export class SidebarComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  @Input() aberto = false
  @Output() fechar = new EventEmitter<void>()

  listMenu: MenuListModel[] = []
  menu: MenuListModel[] = LISTROUTES
  permissions: string[] = []
  menuSelected: string = ''
  permissionsList: any[] = []

  ngOnInit() {
    this.permissionsList = this.authService.getPermissionsObject() ?? []
    for (let i = 0; i < this.permissionsList.length; i++) {
      const item = this.permissionsList[i]
      if (item.modulo.toLowerCase()) {
        this.permissions.push(
          'view-' + item.modulo.toLowerCase().replaceAll(' ', '-').trim(),
        )
      }
    }
    if (this.permissions.length > 0) {
      this.permissions.push('view-sempre')
      this.createMenu()
      this.abrirGrupoDaRotaAtual()
    } else {
      this.router.navigate(['/home'])
    }
  }

  createMenu() {
    const list: MenuListModel[] = []
    for (let indexMenu = 0; indexMenu < this.menu.length; indexMenu++) {
      let menu = this.menu[indexMenu]
      if (menu.type == 'title' && this.permissions.includes(menu.permission!)) {
        list.push(menu)
      } else if (menu.type == 'subTitle') {
        let children: any[] = []
        for (
          let indexSubItem = 0;
          indexSubItem < menu.children!.length;
          indexSubItem++
        ) {
          const child = menu.children![indexSubItem]
          if (this.permissions.includes(child.permission!)) {
            children.push(child)
          }
        }
        if (children.length > 0) {
          let newMenu: any = menu
          newMenu.children = children
          list.push(newMenu)
        }
      }
    }
    this.listMenu = list
  }

  // Deixa aberto o grupo que contém a tela atual
  abrirGrupoDaRotaAtual() {
    const atual = this.router.url.split('?')[0].replace(/^\//, '')
    const grupo = this.listMenu.find(
      (m) => m.type == 'subTitle' && m.children?.some((c) => atual.startsWith(c.route!)),
    )
    if (grupo) this.menuSelected = grupo.label
  }

  icone(label: string) {
    return ICONES_MENU[label] ?? 'chevron_right'
  }

  menuToggle(menu: string) {
    this.menuSelected = this.menuSelected == menu ? '' : menu
  }

  navigateTo(route: string) {
    this.router.navigate([route])
  }

  aoNavegar() {
    this.fechar.emit()
  }
}
